import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDoFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_53223)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1378 41.3792H0.862108C0.386034 41.3792 0 40.9932 0 40.5171V9.48271C0 9.00664 0.386034 8.62061 0.862108 8.62061H49.1379C49.614 8.62061 50 9.00664 50 9.48271V40.5171C49.9999 40.9933 49.6139 41.3792 49.1378 41.3792Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.6896 21.5517H0.862108C0.386034 21.5517 0 21.1657 0 20.6896V9.48271C0 9.00664 0.386034 8.62061 0.862108 8.62061H20.6896C21.1657 8.62061 21.5517 9.00664 21.5517 9.48271V20.6896C21.5517 21.1657 21.1657 21.5517 20.6896 21.5517Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1378 41.3793H29.3104C28.8343 41.3793 28.4482 40.9932 28.4482 40.5172V29.3103C28.4482 28.8343 28.8343 28.4482 29.3104 28.4482H49.1378C49.6139 28.4482 50 28.8343 50 29.3103V40.5173C50 40.9933 49.6139 41.3793 49.1378 41.3793Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M49.1378 21.5517H29.3104C28.8343 21.5517 28.4482 21.1657 28.4482 20.6896V9.48271C28.4482 9.00664 28.8343 8.62061 29.3104 8.62061H49.1378C49.6139 8.62061 50 9.00664 50 9.48271V20.6896C50 21.1657 49.6139 21.5517 49.1378 21.5517Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.6896 41.3793H0.862108C0.386034 41.3793 0 40.9932 0 40.5172V29.3103C0 28.8343 0.386034 28.4482 0.862108 28.4482H20.6896C21.1657 28.4482 21.5517 28.8343 21.5517 29.3103V40.5173C21.5517 40.9933 21.1657 41.3793 20.6896 41.3793Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.5059 27.4584C24.5059 27.4584 25.0209 27.647 24.9537 28.2936L25.1619 28.2897C25.1619 28.2897 25.0306 27.5425 24.922 27.453C24.8134 27.3634 24.5059 27.4584 24.5059 27.4584Z",
					fill: "#64B496"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0213 27.3585C24.8028 27.3585 24.421 27.3582 24.0194 27.2498C24.109 27.1566 24.2327 26.9689 24.2327 26.6417C24.2327 26.1292 23.8796 26.4561 23.8796 26.4561C23.8796 26.4561 23.6474 26.6516 23.7878 27.1739C23.6509 27.1217 23.515 27.0543 23.3856 26.968C23.4661 26.8668 23.6269 26.631 23.7202 26.2572C23.7202 26.2572 23.1317 26.1409 22.9708 26.5841C22.8722 26.459 22.7878 26.3183 22.7174 26.1625C22.8687 26.1644 23.0797 26.0645 23.0797 25.4886C23.0797 25.4886 22.6954 25.4893 22.5928 25.8226C22.5524 25.6832 22.5216 25.5339 22.4989 25.3761C22.6524 25.4206 23.049 25.4525 23.049 24.5917C23.049 24.5917 22.5728 24.5926 22.4625 25.0144C22.4565 24.9065 22.4541 24.795 22.4552 24.68C22.6864 24.5591 23.0056 24.2928 22.9725 23.7464C22.9725 23.7464 22.7528 23.7962 22.5515 23.965C22.5911 23.7579 22.5747 23.4547 22.257 23.2017C22.257 23.2017 21.9651 23.7183 22.3915 24.1377C22.3544 24.1898 22.3221 24.2492 22.2954 24.3151C22.1996 24.1692 22.046 24.0336 21.7985 23.9512C21.7985 23.9512 21.6847 24.6431 22.3307 24.9325C22.346 25.3366 22.4092 25.6936 22.5178 26.0041C22.3327 25.8411 22.183 25.6167 22.183 25.6167C22.183 24.8479 21.5528 24.8285 21.5528 24.8285C21.4352 25.706 22.084 25.7414 22.084 25.7414L22.4393 26.1291C21.6705 26.001 21.6705 26.6416 21.6705 26.6416C22.183 26.7697 22.4393 26.5135 22.4393 26.5135L22.7164 26.6559C22.2248 26.6703 22.0549 27.1541 22.0549 27.1541C22.6728 27.2571 23.1245 27.1118 23.2781 27.0509C23.9004 27.4859 24.6674 27.4865 25.0215 27.4865V27.3585H25.0213Z",
					fill: "#64B496"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.978 27.3585C25.1965 27.3585 25.5783 27.3582 25.9799 27.2498C25.8903 27.1566 25.7666 26.9689 25.7666 26.6417C25.7666 26.1292 26.1197 26.4561 26.1197 26.4561C26.1197 26.4561 26.352 26.6516 26.2115 27.1739C26.3484 27.1217 26.4843 27.0543 26.6138 26.968C26.5332 26.8668 26.3725 26.631 26.2791 26.2572C26.2791 26.2572 26.8676 26.1409 27.0285 26.5841C27.1271 26.459 27.2115 26.3183 27.2819 26.1625C27.1307 26.1644 26.9196 26.0645 26.9196 25.4886C26.9196 25.4886 27.3039 25.4893 27.4067 25.8226C27.4472 25.6832 27.4779 25.5339 27.5006 25.3761C27.3472 25.4206 26.9505 25.4525 26.9505 24.5917C26.9505 24.5917 27.4268 24.5926 27.537 25.0144C27.5431 24.9065 27.5454 24.795 27.5443 24.68C27.3131 24.5591 26.9939 24.2928 27.027 23.7464C27.027 23.7464 27.2467 23.7962 27.448 23.965C27.4084 23.7579 27.4248 23.4547 27.7425 23.2017C27.7425 23.2017 28.0344 23.7183 27.608 24.1377C27.6451 24.1898 27.6774 24.2492 27.7041 24.3151C27.7999 24.1692 27.9535 24.0336 28.201 23.9512C28.201 23.9512 28.3148 24.6431 27.6688 24.9325C27.6535 25.3366 27.5903 25.6936 27.4817 26.0041C27.6668 25.8411 27.8165 25.6167 27.8165 25.6167C27.8165 24.8479 28.4467 24.8285 28.4467 24.8285C28.5643 25.706 27.9155 25.7414 27.9155 25.7414L27.5602 26.1291C28.329 26.001 28.329 26.6416 28.329 26.6416C27.8165 26.7697 27.5602 26.5135 27.5602 26.5135L27.2831 26.6559C27.7747 26.6703 27.9446 27.1541 27.9446 27.1541C27.3268 27.2571 26.875 27.1118 26.7214 27.0509C26.0991 27.4859 25.3321 27.4865 24.978 27.4865V27.3585Z",
					fill: "#64B496"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.8382 21.7729C22.3876 22.0617 21.9904 22.4294 21.6704 22.8635C21.8079 22.9648 21.9454 23.0663 22.0829 23.1677C22.3653 22.7846 22.7158 22.4602 23.1133 22.2052L22.8382 21.7729Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0016 25.104H26.7952V26.129C26.7952 26.4121 26.5658 26.6415 26.2827 26.6415H25.514C25.3034 26.6415 25.1183 26.7444 25.0015 26.9013L25.0016 25.104Z",
					fill: "#FF6B71"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.3857 23.9509V22.5415H27.3076L26.7951 23.054V24.4634H25.3857V23.9509Z",
					fill: "#5F64B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.7949 24.4629H26.1543V25.1035H26.7949V24.4629Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0017 25.104H23.208V26.129C23.208 26.4121 23.4374 26.6415 23.7205 26.6415H24.4893C24.6998 26.6415 24.885 26.7444 25.0018 26.9013L25.0017 25.104Z",
					fill: "#FF6B71"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.6812 26.6727C24.809 26.7135 24.9193 26.7931 24.9985 26.8979H25.0045C25.0838 26.793 25.194 26.7136 25.3219 26.6727V25.6167H24.6812L24.6812 26.6727Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.6172 23.9509V22.5415H22.6953L23.2078 23.054V24.4634H24.6172V23.9509Z",
					fill: "#5F64B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.8486 24.4629H23.208V25.1035H23.8486V24.4629Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.8481 23.1821V23.5665L24.2335 23.8228V23.5665L23.8481 23.1821Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.2329 23.5669V23.9513L24.7454 24.2075V24.0794L24.2329 23.5669Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.1554 23.1821V23.5665L25.77 23.8228V23.5665L26.1554 23.1821Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.7698 23.5669V23.9513L25.2573 24.2075V24.0794L25.7698 23.5669Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.7748 26.0011H24.229C23.8776 26.0011 23.5928 25.7143 23.5928 25.3604V23.3789L25.0112 24.3354L26.4109 23.3789V25.3604C26.4109 25.7143 26.1262 26.0011 25.7748 26.0011Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.1048 23.6949L23.5923 23.3105V24.7199L24.1048 24.9762V23.6949Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.8979 23.6949L26.4105 23.3105V24.7199L25.8979 24.9762V23.6949Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.7699 24.9766H24.2324V25.6172H25.7699V24.9766Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.2329 23.8228L25.0016 24.2071L25.7703 23.8228V24.9759H24.2329V23.8228Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.5783 23.9439V25.2322C25.5783 25.3382 25.4921 25.4243 25.3862 25.4243H24.6175C24.5115 25.4243 24.4254 25.3381 24.4254 25.2322V23.9492L24.041 23.6918V25.2322C24.041 25.5501 24.2996 25.8087 24.6175 25.8087H25.3862C25.7041 25.8087 25.9627 25.5501 25.9627 25.2322V23.6831L25.5783 23.9439Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.7123 24.8389C25.4965 24.8583 25.2536 24.8801 25.0016 24.9678C24.7496 24.8801 24.5066 24.8583 24.2908 24.8389C23.9297 24.8064 23.7154 24.7749 23.5928 24.557V24.9269C23.7812 25.0493 24.0197 25.0718 24.2679 25.0941C24.4906 25.1142 24.7209 25.1348 24.9562 25.2239L25.0017 25.241L25.0471 25.2239C25.2823 25.1348 25.5126 25.1143 25.7354 25.0941C25.9838 25.0719 26.2227 25.0497 26.4111 24.9271V24.5562C26.2884 24.7749 26.0739 24.8064 25.7123 24.8389Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.2575 23.6307H25.0654V23.4385H24.9373V23.6307H24.7451V23.7588H24.9373V24.3354H25.0654V23.7588H25.2575V23.6307Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.8086 23.0493L23.7383 23.1196L24.8641 24.2455L24.9344 24.1752L23.8086 23.0493Z",
					fill: "#464655"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.562 22.873L23.7031 23.1545L23.8442 23.0138L23.562 22.873Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.0673 22.8672L23.9868 22.9258L24.9244 24.2128L25.0048 24.1542L24.0673 22.8672Z",
					fill: "#464655"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.8501 22.6548L23.9458 22.9547L24.107 22.8375L23.8501 22.6548Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.5852 23.2847L23.5283 23.3662L24.8338 24.2777L24.8907 24.1962L23.5852 23.2847Z",
					fill: "#464655"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.3115 23.1553L23.4998 23.4077L23.6141 23.2446L23.3115 23.1553Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0679 24.1743L25.1382 24.2446L26.264 23.1188L26.1937 23.0485L25.0679 24.1743Z",
					fill: "#464655"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4404 22.873L26.2993 23.1545L26.1582 23.0138L26.4404 22.873Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9982 24.1528L25.0786 24.2114L26.0161 22.9244L25.9357 22.8658L24.9982 24.1528Z",
					fill: "#464655"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.1528 22.6548L26.0572 22.9547L25.896 22.8375L26.1528 22.6548Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.1135 24.1973L25.1704 24.2788L26.4758 23.3673L26.4189 23.2858L25.1135 24.1973Z",
					fill: "#464655"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.6917 23.1553L26.5034 23.4077L26.3892 23.2446L26.6917 23.1553Z",
					fill: "#FFE15A"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9366 26.605C24.9366 26.605 24.4411 26.0729 24.5373 25.5844C24.6145 25.1916 24.849 24.7585 25.0325 24.6531C25.0325 24.6531 25.292 24.6371 25.2269 24.8625C25.1619 25.0878 25.0826 25.1459 25.1058 25.3681C25.1458 25.7527 25.2078 26.2084 24.9366 26.605Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0865 24.6563C25.0555 24.6522 25.032 24.6535 25.032 24.6535C24.8485 24.7589 24.614 25.192 24.5368 25.5849C24.493 25.8071 24.572 26.0378 24.6709 26.2238C24.6083 25.4184 24.8434 25.1326 25.0865 24.6563Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.106 25.3686C25.0828 25.1464 25.1622 25.0883 25.2274 24.8629C25.2732 24.7052 25.1596 24.6657 25.0872 24.6562C25.0872 24.6562 24.9214 25.0363 24.9107 25.2913C24.9013 25.5156 24.9589 26.4284 24.9366 26.6056C25.2085 26.2086 25.1463 25.7529 25.106 25.3686Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.7695 24.8459C24.8728 24.7452 25.0179 24.7002 25.1601 24.7246C25.0927 24.5077 25.0253 24.2908 24.9579 24.0739C24.8159 24.0495 24.6707 24.0946 24.5674 24.1951C24.6347 24.4121 24.7021 24.629 24.7695 24.8459Z",
					fill: "#F5F0F0"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.1602 24.7248C25.2634 24.6241 25.4085 24.5791 25.5507 24.6035C25.4833 24.3866 25.4159 24.1698 25.3485 23.9528C25.2065 23.9284 25.0613 23.9735 24.958 24.0741C25.0253 24.2909 25.0927 24.5078 25.1602 24.7248Z",
					fill: "#F3F3F3"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.4162 21.9096C23.7207 21.8935 23.0338 22.0645 22.427 22.4047C22.3435 22.2557 22.2599 22.1066 22.1763 21.9577C22.8631 21.5726 23.6407 21.379 24.428 21.3972C24.424 21.568 24.42 21.7388 24.4162 21.9096Z",
					fill: "#5F64B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.1647 21.7729C27.6153 22.0617 28.0125 22.4294 28.3325 22.8635C28.195 22.9648 28.0575 23.0663 27.92 23.1677C27.6376 22.7846 27.2871 22.4602 26.8896 22.2052L27.1647 21.7729Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.5865 21.9096C26.282 21.8935 26.9689 22.0645 27.5758 22.4047C27.6593 22.2557 27.7429 22.1066 27.8265 21.9577C27.1396 21.5726 26.362 21.379 25.5747 21.3972C25.5787 21.568 25.5827 21.7388 25.5865 21.9096Z",
					fill: "#5F64B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.0265 21.7732C25.3555 21.5896 24.6475 21.5896 23.9766 21.7732C23.9315 21.6084 23.8863 21.4437 23.8413 21.2788C24.6008 21.0711 25.4021 21.0711 26.1617 21.2788C26.1167 21.4436 26.0716 21.6083 26.0265 21.7732Z",
					fill: "#41479B"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M23.2841 27.5156C22.7311 27.6601 22.1904 27.8549 21.6699 28.1001C21.7428 28.2546 21.8156 28.4092 21.8884 28.5637C22.3906 28.327 22.9127 28.1401 23.447 28.0029L23.2841 27.5156Z",
					fill: "#FF6B71"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.7181 27.5156C27.2711 27.6601 27.8117 27.8549 28.3322 28.1001C28.2594 28.2546 28.1865 28.4092 28.1138 28.5637C27.6115 28.327 27.0895 28.1401 26.5552 28.0029L26.7181 27.5156Z",
					fill: "#FF6B71"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.0623 27.9118C25.7147 27.5882 24.31 27.5882 22.9624 27.9118C22.9226 27.7456 22.8826 27.5795 22.8428 27.4135C24.2688 27.0711 25.7559 27.0711 27.1819 27.4135C27.1422 27.5795 27.1022 27.7458 27.0623 27.9118Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0022 28.0509L24.6489 28.1393C24.5681 28.1595 24.4897 28.0984 24.4897 28.0151V27.8308C24.4897 27.7475 24.5681 27.6862 24.6489 27.7066L25.0022 27.7949V28.0509Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.002 27.7949L25.3553 27.7065C25.4361 27.6863 25.5145 27.7474 25.5145 27.8307V28.015C25.5145 28.0983 25.4361 28.1596 25.3553 28.1392L25.002 28.0509V27.7949Z",
					fill: "#CD343C"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25.0291 28.0508H24.974C24.9183 28.0508 24.873 28.0058 24.873 27.9501V27.8951C24.873 27.8396 24.9182 27.7944 24.974 27.7944H25.0291C25.0848 27.7944 25.1301 27.8395 25.1301 27.8951V27.9501C25.13 28.0058 25.0848 28.0508 25.0291 28.0508Z",
					fill: "#FF6B71"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_53223",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgDoFlag);
export { ForwardRef as ReactComponent };
